import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";

function Waiting (){

    return(

        <>
        <Header/>
  {/*===== SHOP AREA START =====*/}
  <div className="shop3-area sp sec-bg2">
    <div className="container">
      <div className="row">
        <div className="col-lg-6 m-auto text-center">
          <div className="heading3">
            <span
              className="sub-title"
              data-aos="zoom-in-left"
              data-aos-duration={900}
            >
              <img src="assets/img/icons/span4.svg" alt="" /> Waiting for Publication
            </span>
            <h2 className="text-anime-style-3">Our Showcase</h2>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-8 m-auto">
          <div className="shop-tab-btn">
            <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link active"
                  id="shop1-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#shop1"
                  type="button"
                  role="tab"
                  aria-controls="shop1"
                  aria-selected="true"
                >
                  {/* Water Bottles */}
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="shop2-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#shop2"
                  type="button"
                  role="tab"
                  aria-controls="shop2"
                  aria-selected="false"
                >
                  {/* Material Bottle */}
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="shop3-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#shop3"
                  type="button"
                  role="tab"
                  aria-controls="shop3"
                  aria-selected="false"
                >
                  {/* Plastic Bottles */}
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="shop4-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#shop4"
                  type="button"
                  role="tab"
                  aria-controls="shop4"
                  aria-selected="false"
                >
                  {/* Glass Jar */}
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="shop5-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#shop5"
                  type="button"
                  role="tab"
                  aria-controls="shop5"
                  aria-selected="false"
                >
                  {/* Plastic Jar */}
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="shop-tab-contents">
          <div className="tab-content" id="pills-tabContent">
            <div
              className="tab-pane fade show active"
              id="shop1"
              role="tabpanel"
              aria-labelledby="shop1-tab"
            >
              <div className="row">
                <div
                  className="col-lg-3 col-md-6"
                  data-aos="fade-up"
                  data-aos-duration={900}
                  data-aos-delay={200}
                >
                  <div className="shop3-item mt-40">
                    <div className="image-area">
                      <div className="image">
                        <img src="assets/img/shop/shop3-image1.png" alt="" />
                      </div>
                      <div className="button">
                        <a className="theme-btn7" href="contact.html">
                          Order Now
                        </a>
                      </div>
                    </div>
                    <div className="content">
                      <h6>Blue Water Bottle</h6>
                      <h3>$15.99</h3>
                    </div>
                  </div>
                </div>
                <div
                  className="col-lg-3 col-md-6"
                  data-aos="fade-up"
                  data-aos-duration={900}
                  data-aos-delay={300}
                >
                  <div className="shop3-item mt-40">
                    <div className="image-area">
                      <div className="image">
                        <img src="assets/img/shop/shop3-image2.png" alt="" />
                      </div>
                      <div className="button">
                        <a className="theme-btn7" href="contact.html">
                          Order Now
                        </a>
                      </div>
                    </div>
                    <div className="content">
                      <h6>Navy Hub Water Bottle</h6>
                      <h3>$19.99</h3>
                    </div>
                  </div>
                </div>
                <div
                  className="col-lg-3 col-md-6"
                  data-aos="fade-up"
                  data-aos-duration={900}
                  data-aos-delay={400}
                >
                  <div className="shop3-item mt-40">
                    <div className="image-area">
                      <div className="image">
                        <img src="assets/img/shop/shop3-image3.png" alt="" />
                      </div>
                      <div className="button">
                        <a className="theme-btn7" href="contact.html">
                          Order Now
                        </a>
                      </div>
                    </div>
                    <div className="content">
                      <h6>Cyber White Bottle</h6>
                      <h3>$19.99</h3>
                    </div>
                  </div>
                </div>
                <div
                  className="col-lg-3 col-md-6"
                  data-aos="fade-up"
                  data-aos-duration={900}
                  data-aos-delay={500}
                >
                  <div className="shop3-item mt-40">
                    <div className="image-area">
                      <div className="image">
                        <img src="assets/img/shop/shop3-image4.png" alt="" />
                      </div>
                      <div className="button">
                        <a className="theme-btn7" href="contact.html">
                          Order Now
                        </a>
                      </div>
                    </div>
                    <div className="content">
                      <h6>Wood Water Bottle</h6>
                      <h3>$24.99</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="shop2"
              role="tabpanel"
              aria-labelledby="shop2-tab"
            >
              <div className="row">
                <div className="col-lg-3 col-md-6">
                  <div className="shop3-item mt-40">
                    <div className="image-area">
                      <div className="image">
                        <img src="assets/img/shop/shop3-image4.png" alt="" />
                      </div>
                      <div className="button">
                        <a className="theme-btn7" href="contact.html">
                          Order Now
                        </a>
                      </div>
                    </div>
                    <div className="content">
                      <h6>Wood Water Bottle</h6>
                      <h3>$24.99</h3>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="shop3-item mt-40">
                    <div className="image-area">
                      <div className="image">
                        <img src="assets/img/shop/shop3-image1.png" alt="" />
                      </div>
                      <div className="button">
                        <a className="theme-btn7" href="contact.html">
                          Order Now
                        </a>
                      </div>
                    </div>
                    <div className="content">
                      <h6>Blue Water Bottle</h6>
                      <h3>$15.99</h3>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="shop3-item mt-40">
                    <div className="image-area">
                      <div className="image">
                        <img src="assets/img/shop/shop3-image2.png" alt="" />
                      </div>
                      <div className="button">
                        <a className="theme-btn7" href="contact.html">
                          Order Now
                        </a>
                      </div>
                    </div>
                    <div className="content">
                      <h6>Navy Hub Water Bottle</h6>
                      <h3>$19.99</h3>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="shop3-item mt-40">
                    <div className="image-area">
                      <div className="image">
                        <img src="assets/img/shop/shop3-image3.png" alt="" />
                      </div>
                      <div className="button">
                        <a className="theme-btn7" href="contact.html">
                          Order Now
                        </a>
                      </div>
                    </div>
                    <div className="content">
                      <h6>Cyber White Bottle</h6>
                      <h3>$19.99</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="shop3"
              role="tabpanel"
              aria-labelledby="shop3-tab"
            >
              <div className="row">
                <div className="col-lg-3 col-md-6">
                  <div className="shop3-item mt-40">
                    <div className="image-area">
                      <div className="image">
                        <img src="assets/img/shop/shop3-image3.png" alt="" />
                      </div>
                      <div className="button">
                        <a className="theme-btn7" href="contact.html">
                          Order Now
                        </a>
                      </div>
                    </div>
                    <div className="content">
                      <h6>Cyber White Bottle</h6>
                      <h3>$19.99</h3>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="shop3-item mt-40">
                    <div className="image-area">
                      <div className="image">
                        <img src="assets/img/shop/shop3-image4.png" alt="" />
                      </div>
                      <div className="button">
                        <a className="theme-btn7" href="contact.html">
                          Order Now
                        </a>
                      </div>
                    </div>
                    <div className="content">
                      <h6>Wood Water Bottle</h6>
                      <h3>$24.99</h3>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="shop3-item mt-40">
                    <div className="image-area">
                      <div className="image">
                        <img src="assets/img/shop/shop3-image1.png" alt="" />
                      </div>
                      <div className="button">
                        <a className="theme-btn7" href="contact.html">
                          Order Now
                        </a>
                      </div>
                    </div>
                    <div className="content">
                      <h6>Blue Water Bottle</h6>
                      <h3>$15.99</h3>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="shop3-item mt-40">
                    <div className="image-area">
                      <div className="image">
                        <img src="assets/img/shop/shop3-image2.png" alt="" />
                      </div>
                      <div className="button">
                        <a className="theme-btn7" href="contact.html">
                          Order Now
                        </a>
                      </div>
                    </div>
                    <div className="content">
                      <h6>Navy Hub Water Bottle</h6>
                      <h3>$19.99</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="shop4"
              role="tabpanel"
              aria-labelledby="shop4-tab"
            >
              <div className="row">
                <div className="col-lg-3 col-md-6">
                  <div className="shop3-item mt-40">
                    <div className="image-area">
                      <div className="image">
                        <img src="assets/img/shop/shop3-image2.png" alt="" />
                      </div>
                      <div className="button">
                        <a className="theme-btn7" href="contact.html">
                          Order Now
                        </a>
                      </div>
                    </div>
                    <div className="content">
                      <h6>Navy Hub Water Bottle</h6>
                      <h3>$19.99</h3>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="shop3-item mt-40">
                    <div className="image-area">
                      <div className="image">
                        <img src="assets/img/shop/shop3-image3.png" alt="" />
                      </div>
                      <div className="button">
                        <a className="theme-btn7" href="contact.html">
                          Order Now
                        </a>
                      </div>
                    </div>
                    <div className="content">
                      <h6>Cyber White Bottle</h6>
                      <h3>$19.99</h3>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="shop3-item mt-40">
                    <div className="image-area">
                      <div className="image">
                        <img src="assets/img/shop/shop3-image4.png" alt="" />
                      </div>
                      <div className="button">
                        <a className="theme-btn7" href="contact.html">
                          Order Now
                        </a>
                      </div>
                    </div>
                    <div className="content">
                      <h6>Wood Water Bottle</h6>
                      <h3>$24.99</h3>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="shop3-item mt-40">
                    <div className="image-area">
                      <div className="image">
                        <img src="assets/img/shop/shop3-image1.png" alt="" />
                      </div>
                      <div className="button">
                        <a className="theme-btn7" href="contact.html">
                          Order Now
                        </a>
                      </div>
                    </div>
                    <div className="content">
                      <h6>Blue Water Bottle</h6>
                      <h3>$15.99</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="shop5"
              role="tabpanel"
              aria-labelledby="shop5-tab"
            >
              <div className="row">
                <div className="col-lg-3 col-md-6">
                  <div className="shop3-item mt-40">
                    <div className="image-area">
                      <div className="image">
                        <img src="assets/img/shop/shop3-image2.png" alt="" />
                      </div>
                      <div className="button">
                        <a className="theme-btn7" href="contact.html">
                          Order Now
                        </a>
                      </div>
                    </div>
                    <div className="content">
                      <h6>Navy Hub Water Bottle</h6>
                      <h3>$19.99</h3>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="shop3-item mt-40">
                    <div className="image-area">
                      <div className="image">
                        <img src="assets/img/shop/shop3-image3.png" alt="" />
                      </div>
                      <div className="button">
                        <a className="theme-btn7" href="contact.html">
                          Order Now
                        </a>
                      </div>
                    </div>
                    <div className="content">
                      <h6>Cyber White Bottle</h6>
                      <h3>$19.99</h3>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="shop3-item mt-40">
                    <div className="image-area">
                      <div className="image">
                        <img src="assets/img/shop/shop3-image4.png" alt="" />
                      </div>
                      <div className="button">
                        <a className="theme-btn7" href="contact.html">
                          Order Now
                        </a>
                      </div>
                    </div>
                    <div className="content">
                      <h6>Wood Water Bottle</h6>
                      <h3>$24.99</h3>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="shop3-item mt-40">
                    <div className="image-area">
                      <div className="image">
                        <img src="assets/img/shop/shop3-image1.png" alt="" />
                      </div>
                      <div className="button">
                        <a className="theme-btn7" href="contact.html">
                          Order Now
                        </a>
                      </div>
                    </div>
                    <div className="content">
                      <h6>Blue Water Bottle</h6>
                      <h3>$15.99</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/*===== SHOP AREA END =====*/}

  <Footer/>
</>

    )
}

export default Waiting;